import { jsdomReactUniDriver } from '@wix/unidriver-jsdom-react-legacy';

export { jsdomReactUniDriver };
export { jsdomReactUniDriver as reactUniDriver };

export * from './vanilla';
